<template>
    <span v-b-tooltip.hover title="Refresh">
        <i
            class="refresh-resource fa fa-refresh pointer-action"
            @click="refreshResource(resource)"
            variant="warning"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        resource: {
            required: true,
            type: Object,
        },
        refreshResource: {
            required: true,
            type: Function,
        },
    },
}
</script>

<style>
.refresh-resource {
    font-weight: 600;
}
</style>
